module.exports = __webpack_public_path__ + "img/create-scenario.f204d00a.png";